/**
 * Dagobah-Web-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ProjectInProjectList model module.
 * @module model/ProjectInProjectList
 * @version 2.8.0
 */
class ProjectInProjectList {
    /**
     * Constructs a new <code>ProjectInProjectList</code>.
     * @alias module:model/ProjectInProjectList
     * @param id {String} 
     * @param name {String} 
     * @param userId {String} 
     * @param collections {Array.<String>} 
     * @param creationDate {String} 
     */
    constructor(id, name, userId, collections, creationDate) { 
        
        ProjectInProjectList.initialize(this, id, name, userId, collections, creationDate);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, id, name, userId, collections, creationDate) { 
        obj['id'] = id;
        obj['name'] = name;
        obj['userId'] = userId;
        obj['collections'] = collections;
        obj['creationDate'] = creationDate;
    }

    /**
     * Constructs a <code>ProjectInProjectList</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ProjectInProjectList} obj Optional instance to populate.
     * @return {module:model/ProjectInProjectList} The populated <code>ProjectInProjectList</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ProjectInProjectList();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'String');
            }
            if (data.hasOwnProperty('collections')) {
                obj['collections'] = ApiClient.convertToType(data['collections'], ['String']);
            }
            if (data.hasOwnProperty('creationDate')) {
                obj['creationDate'] = ApiClient.convertToType(data['creationDate'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} id
 */
ProjectInProjectList.prototype['id'] = undefined;

/**
 * @member {String} name
 */
ProjectInProjectList.prototype['name'] = undefined;

/**
 * @member {String} userId
 */
ProjectInProjectList.prototype['userId'] = undefined;

/**
 * @member {Array.<String>} collections
 */
ProjectInProjectList.prototype['collections'] = undefined;

/**
 * @member {String} creationDate
 */
ProjectInProjectList.prototype['creationDate'] = undefined;






export default ProjectInProjectList;

